export default "__VITE_ASSET__C_1GTktk__"